export const modalOptions = {
  HOLD_VEHICLE: "Place Vehicle on Hold",
  MODIFY_HOLD: "Modify Vehicle Hold",
  WORKSHOP_VEHICLE: "Place Vehicle in Workshop",
  ADDITIONAL_HOLD_REASON: "Additional Hold Reason",
  WORKSHOP_REASON: "Workshop Reason",
};